import { Component, Input, OnChanges } from '@angular/core';
import { OrganizationMemberInvitationSteps } from '../enums/organization-member-invitation-steps';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoPipe } from '@jsverse/transloco';

export enum StepperStates {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  DONE = 'done',
}

@Component({
  selector: 'markant-platform-organization-member-invitation-stepper',
  templateUrl: './organization-member-invitation-stepper.component.html',
  styleUrls: ['./organization-member-invitation-stepper.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoPipe],
})
export class OrganizationMemberInvitationStepperComponent implements OnChanges {
  @Input() currentStep: OrganizationMemberInvitationSteps = OrganizationMemberInvitationSteps.USER;

  userState: StepperStates = StepperStates.ACTIVE;
  roleState: StepperStates = StepperStates.INACTIVE;
  groupState: StepperStates = StepperStates.INACTIVE;
  cartridgeState: StepperStates = StepperStates.INACTIVE;

  ngOnChanges(): void {
    switch (this.currentStep) {
      case OrganizationMemberInvitationSteps.USER:
        this.userState = StepperStates.ACTIVE;
        this.roleState = StepperStates.INACTIVE;
        this.groupState = StepperStates.INACTIVE;
        this.cartridgeState = StepperStates.INACTIVE;
        break;
      case OrganizationMemberInvitationSteps.ROLE:
        this.userState = StepperStates.DONE;
        this.roleState = StepperStates.ACTIVE;
        this.groupState = StepperStates.INACTIVE;
        this.cartridgeState = StepperStates.INACTIVE;
        break;
      case OrganizationMemberInvitationSteps.GROUP:
        this.userState = StepperStates.DONE;
        this.roleState = StepperStates.DONE;
        this.groupState = StepperStates.ACTIVE;
        this.cartridgeState = StepperStates.INACTIVE;
        break;
      case OrganizationMemberInvitationSteps.CARTRIDGE:
        this.userState = StepperStates.DONE;
        this.roleState = StepperStates.DONE;
        this.groupState = StepperStates.DONE;
        this.cartridgeState = StepperStates.ACTIVE;
        break;
    }
  }
}
